import { IApplicationState } from '../../types/redux';

export const selectIsAuthenticated = (state: IApplicationState) => {
  return Boolean(state.user?.isAuthenticated);
};
